import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toastError, toastSuccess } from "../../utils";
import { createBusiness } from "../../services/services";
import { logout } from "../../redux/auth/authSlice";

const CreateBusiness = ({ onBackToLogin, onBusinessCreated }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token, user } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    userName: "",
    userEmail: "",
    businessName: "",
    businessEmail: "",
    gstNo: "",
    businessPhone: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};

    // ---- BUSINESS ----
    if (!formData.businessName.trim())
      newErrors.businessName = "Business name is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      const payload = {
        userId: user?._id,
        userEmail: formData.userEmail,
        userName: formData.userName,
        businessName: formData.businessName,
        phone: formData.businessPhone,
        gstNumber: formData.gstNo,
        email: formData.businessEmail,
        address: "",
        state: "",
        pin: "",
        category: "",
      };

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await createBusiness(payload, config);

      if (data.status) {
        const updatedUser = data?.response?.user || null;
        const newToken = data?.response?.token || null;

        if (updatedUser) {
          localStorage.setItem("Login_User", JSON.stringify(updatedUser));
        }

        if (newToken) {
          localStorage.setItem("User_Token", newToken);
        }
        if (updatedUser)
          localStorage.setItem("Login_User", JSON.stringify(updatedUser));

        toastSuccess("Business created successfully!");

        const hasPin = Boolean(updatedUser?.pin);

        onBusinessCreated({
          business: data.response.business,
          user: updatedUser,
        });
      } else {
        toastError(data.message || "Error creating business");
      }
    } catch (err) {
      console.error("Business creation error:", err);
      toastError(err.response?.data?.message || "Failed to create business");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    dispatch(logout());
    localStorage.clear();

    if (typeof onBackToLogin === "function") {
      onBackToLogin();
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="card">
      <div className="card-body">
        <div className="text-start">
          <h3
            className="fw-bold fs-2"
            style={{
              background:
                "linear-gradient(45deg, rgb(12, 30, 126), rgb(2, 226, 208))",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Assist Buddi Book
          </h3>

          <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
            Create your business profile to get started
          </p>
        </div>

        <div className="overflow-hidden">
          <div
            className="py-4"
            style={{
              overflowY: "auto",
              maxHeight: "calc(100vh - 180px)",
              overflowX: "hidden",
            }}
          >
            <form onSubmit={handleSubmit}>
              <div className="mb-3 row align-items-center">
                <label className="col-sm-4 col-form-label fw-semibold text-secondary">
                  Full Name
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="userName"
                    className={`form-control form-control-sm shadow-sm ${
                      errors.userName ? "is-invalid" : ""
                    }`}
                    placeholder="Enter your full name"
                    value={formData.userName}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Email */}
              <div className="mb-3 row align-items-center">
                <label className="col-sm-4 col-form-label fw-semibold text-secondary">
                  Email
                </label>
                <div className="col-sm-8">
                  <input
                    type="email"
                    name="userEmail"
                    className={`form-control form-control-sm shadow-sm ${
                      errors.userEmail ? "is-invalid" : ""
                    }`}
                    placeholder="Enter your email address"
                    value={formData.userEmail}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* === BUSINESS DETAILS === */}
              <h5 className="fw-semibold border-bottom pb-2 mb-2 mt-5">
                Business Details
              </h5>

              {/* Business Name */}
              <div className="mb-3 row align-items-center">
                <label className="col-sm-4 col-form-label fw-semibold text-secondary">
                  Business Name
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="businessName"
                    className={`form-control form-control-sm shadow-sm ${
                      errors.businessName ? "is-invalid" : ""
                    }`}
                    placeholder="Enter business name"
                    value={formData.businessName}
                    onChange={handleChange}
                  />
                  {errors.businessName && (
                    <div className="invalid-feedback">
                      {errors.businessName}
                    </div>
                  )}
                </div>
              </div>

              {/* GST */}
              <div className="mb-3 row align-items-center">
                <label className="col-sm-4 col-form-label fw-semibold text-secondary">
                  GST Number
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="gstNo"
                    className={`form-control form-control-sm shadow-sm ${
                      errors.gstNo ? "is-invalid" : ""
                    }`}
                    placeholder="Enter 15-character GSTIN"
                    maxLength="15"
                    value={formData.gstNo.toUpperCase()}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Business Email */}
              <div className="mb-3 row align-items-center">
                <label className="col-sm-4 col-form-label fw-semibold text-secondary">
                  Email
                </label>
                <div className="col-sm-8">
                  <input
                    type="email"
                    name="businessEmail"
                    className={`form-control form-control-sm shadow-sm ${
                      errors.businessEmail ? "is-invalid" : ""
                    }`}
                    placeholder="Enter business email"
                    value={formData.businessEmail}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Business Phone */}
              <div className="mb-2 row align-items-center">
                <label className="col-sm-4 col-form-label fw-semibold text-secondary">
                  Contact
                </label>
                <div className="col-sm-8">
                  <input
                    type="tel"
                    name="businessPhone"
                    className={`form-control form-control-sm shadow-sm ${
                      errors.businessPhone ? "is-invalid" : ""
                    }`}
                    placeholder="Enter business contact"
                    maxLength="10"
                    value={formData.businessPhone}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Submit */}
              <div className="text-center mt-4">
                <button
                  type="submit"
                  className="btn btn-primary w-100 py-2 fw-semibold shadow-sm"
                  style={{
                    backgroundColor: "#0b2b6d",
                    border: "none",
                    letterSpacing: "0.3px",
                  }}
                  disabled={loading}
                >
                  {loading ? (
                    <span>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </span>
                  ) : (
                    "Save & Continue"
                  )}
                </button>
                <p
                  className="text-center mt-3 mb-0"
                  style={{ fontSize: "14px" }}
                >
                  Already have an account?{" "}
                  <span
                    role="button"
                    onClick={handleCancel}
                    className="fw-semibold text-primary"
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                  >
                    Login
                  </span>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateBusiness;
